/**
 * Operational SoT: prefer ss_units columns; instance_* only for legacy rows
 * (API serializeSsUnit already flattens these when present).
 */
export function resolveUnitOps(unit) {
  if (!unit || typeof unit !== 'object') {
    return {
      location: '',
      inspection_frequency: null,
      inspection_method_type: 'UNIFORM',
      inspection_method_notes: '',
    };
  }
  return {
    location: (unit.location || unit.instance_location || '').trim(),
    inspection_frequency:
      unit.inspection_frequency || unit.instance_inspection_frequency || null,
    inspection_method_type:
      unit.inspection_method_type || unit.instance_inspection_method_type || 'UNIFORM',
    inspection_method_notes:
      unit.inspection_method_notes || unit.instance_inspection_method_notes || '',
  };
}

/** Confirmed inspection questions count (unit registry snapshot). */
export function confirmedChecklistCount(unit) {
  if (unit?.confirmed_checklist_count != null) return Number(unit.confirmed_checklist_count) || 0;
  const raw =
    unit?.confirmed_checklist ||
    unit?.confirmed_checklist_json ||
    unit?.confirmed_checklist_meta?.item_count;
  if (typeof raw === 'number') return raw;
  if (Array.isArray(raw)) return raw.length;
  if (typeof raw === 'string') {
    try {
      const p = JSON.parse(raw);
      return Array.isArray(p) ? p.length : 0;
    } catch {
      return 0;
    }
  }
  return 0;
}

/**
 * Registered equipment sub-type label (e.g. Fire pump, Wet pipe system, Default).
 * Used for Set System Name and the Floor Plan unit-ID panel subtitle.
 */
export function resolveUnitTypeDisplayName(unit, options = {}) {
  const { equipmentTypes, instance } = options;
  const types = equipmentTypes || instance?.equipment_types || [];
  const etId = unit?.equipment_type_id;
  if (etId && types.length) {
    const et = types.find((t) => String(t.id) === String(etId));
    if (et?.label) return String(et.label).trim();
  }

  const unitType = String(unit?.unit_type || '').trim();
  if (unitType) return unitType;

  return String(unit?.name || '').trim();
}

/** Normalize "SS 15.2" / "15.2" / "SS SS 15.2" → single leading "SS 15.2". */
export function formatSsLabel(ssCode) {
  let bare = String(ssCode || '').trim();
  while (/^SS\s+/i.test(bare)) {
    bare = bare.replace(/^SS\s+/i, '').trim();
  }
  return bare ? `SS ${bare}` : '';
}

/** Display title e.g. "SS 15.2 Final Exits" (never "SS SS …"). */
export function unitDisplayTitle(unit) {
  const ssLabel = formatSsLabel(unit?.ss_code);
  const ssBare = ssLabel.replace(/^SS\s+/i, '').trim();
  const loc = resolveUnitOps(unit).location;
  const name = (unit?.name || '').trim();
  let source = loc || name;
  while (/^SS\s+/i.test(source)) {
    source = source.replace(/^SS\s+/i, '').trim();
  }
  if (!ssLabel && !source) return 'SS unit';
  if (!source) return ssLabel || 'SS unit';
  const lower = source.toLowerCase();
  if (ssBare && lower.startsWith(ssBare.toLowerCase())) {
    return `SS ${source}`;
  }
  return ssLabel ? `${ssLabel} ${source}` : `SS ${source}`;
}
